import { Dialog } from '@/components/ui/Dialog'
import { closeXlsxPreview, useXlsxPreviewDoc } from '@/lib/xlsxPreview'
import { XlsxSheets, useXlsxSheets } from '@/components/documents/XlsxSheets'

// In-app spreadsheet viewer. Mounted ONCE (OperationsLayout); shows whenever
// `openXlsxPreview` is called. Renders every sheet as an HTML table from the
// ORIGINAL xlsx — lossless, all data, nothing truncated. SheetJS is lazy-loaded
// (~1MB) so it never bloats the main bundle, and parsing happens in the browser
// (the bytes never leave the client — no third-party viewer).
export function XlsxPreviewModal() {
  const doc = useXlsxPreviewDoc()
  // O MESMO miolo que o visualizador de documentos desenha no sítio — ver `XlsxSheets`. Esta
  // janela fica só com a chrome e o botão de descarregar.
  const { sheets, bytes, error, loading } = useXlsxSheets(doc?.id ?? null)

  // Reuse the already-fetched bytes (no extra request) to download the ORIGINAL
  // file with its real name — a cross-origin `download` attr on the signed R2
  // URL would be ignored, but a same-origin blob URL forces the download.
  function download() {
    if (!bytes || !doc) return
    const url = URL.createObjectURL(new Blob([bytes], { type: 'application/octet-stream' }))
    const a = document.createElement('a')
    a.href = url
    a.download = doc.filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  }

  return (
    <Dialog
      open={!!doc}
      onClose={closeXlsxPreview}
      title={
        <div className="flex items-center justify-between gap-3">
          <span className="min-w-0 truncate">{doc?.filename ?? ''}</span>
          {bytes && (
            <button
              type="button"
              onClick={download}
              className="flex flex-shrink-0 items-center gap-1.5 rounded-md bg-brand-50 px-2.5 py-1 text-[12px] font-medium text-brand-800 hover:bg-brand-100"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Descarregar
            </button>
          )}
        </div>
      }
      widthClassName="max-w-6xl"
    >
      <XlsxSheets sheets={sheets} loading={loading} error={error} tablesClassName="max-h-[70vh]" />
    </Dialog>
  )
}
